<div class="db-refund-info">
  <div>
    <p><span>{{ 'text_refundDate' | dbText }}</span> {{(refund?.dateCreated | dbDate : 'dd MMM y, HH:mm' : true)}}</p>
    <p><span>{{ 'text_refundReason' | dbText }}</span> {{refund.reason}}</p>
  </div>

  <db-refund-price [price]="'-$' + refund?.amount"></db-refund-price>
</div>
